export default function formatToMDY(dateString:any) {
    const date = new Date(dateString);
  
    // getMonth() returns 0-based index, so add 1
    const month = date.getMonth() + 1; 
    const day = date.getDate();
    const year = date.getFullYear();
  
    return `${month}/${day}/${year}`;
  }
  
  // Example usage:
  const formattedDate = formatToMDY("2024-03-20 14:30:45");
  console.log(formattedDate); 
  // Outputs: "3/20/2024"
  